var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /~/react-sortable-hoc/~/lodash/_Symbol.js
// module id = 234
// module chunks = 0